<template>
  <div>
    <div class="topbar">
      <div class="clearfix main-wrap">
        <a class="img-back pull-left" href="javascript:window.history.go(-1)">返回</a>
        <h1>提醒</h1>
        <router-link class="pull-right icon-right icon-setup text-hide" :to="{path:'/remind/add'}" tag="span">添加提醒</router-link>
      </div>
      <div class="liner"></div>
    </div>


    <!-- <mt-loadmore :top-method="loadTop" ref="loadmore"> -->
    <!-- <div class="main-page" v-infinite-scroll="loadBottom"
    infinite-scroll-disabled="isGetting"
    infinite-scroll-distance="150"> -->
    <div class="main-page">
      <div class="remind-list">
        <ul class="list-group-item primary">
        <!--开关效果-->
        <router-link class="list-group" v-for="item in remindTimeList" :to="{path: '/remind/edit/' + item.curcheHandsTimeId}" tag="li">
          <div class="liner"></div>
          <div class="clearfix">
            <div>
              <span class="font-18 block">{{item.handsTime}}</span>
              <p class="font-12 gray">
              <span v-for="week in item.weekList">{{week.week}}&nbsp;&nbsp;</span>
              </p>
            </div>
            <div class="pull-right" style="margin-top:-35px" @click.stop="setTimeState(item)">
              <div class="mint-switch">
                <input class="mint-switch-input" type="checkbox" checked v-if="item.stateFlag">
                <input class="mint-switch-input" type="checkbox" v-else>
                <span class="mint-switch-core"></span>
                <div class="mint-switch-label"></div>
              </div>
            </div>
          </div>
        </router-link>
        <!--开关效果end-->
        </ul>
        
          <div class="padding-15">
            <span class="font-14 block">温馨提示</span>
            <p class="gray font-12" style="margin-top:5px;">设置提醒消息后，系统在您指定的时间内自动向指定的家长APP上发送一条提醒消息，消息文字您可以自由编写！</p>
          </div>
        
      </div>
    </div>
  </div>
    <!-- </mt-loadmore> -->
</template>

<script>
import { service } from '../../service'
// import { Switch } from 'mint-ui'
export default {
  data () {
    return {
      cookie_login_data: JSON.parse(window.localStorage['basic_login_data']),
      get_remaind_time_list_para: service.setPara('getRemindTimeList'),
      set_time_state_para: service.setPara('setTimeState'),
      remindTimeList: []
    }
  },
  mounted: function () {
    this.setPara()
    this.getRemindTimeList()
  },
  methods: {
    setPara: function () {
      this.get_remaind_time_list_para.curcheId = this.cookie_login_data.curcheId
    },
    getRemindTimeList: function () {
      let obj = {context: this, para: this.get_remaind_time_list_para, successFun: (response) => {
        let list = response.data
        for (let i = 0; i < list.length; i++) {
          if (list[i].weekList.length == 7) {
            list[i].weekList = []
            list[i].weekList[0] = {week: '每天'}
          }
          if (list[i].state == 0) {
            list[i].stateFlag = false
          } else {
            list[i].stateFlag = true
          }
        }
        this.remindTimeList = list
      }}
      service.request(obj)
    },
    setTimeState: function (item) {
      item.stateFlag = !item.stateFlag
      // alert(item.stateFlag + ':' + item.curcheHandsTimeId)
      // let b = window.browser()
      // if (b.android) {
      //   this.set_time_state_para.state = item.stateFlag ? 0 : 1
      // } else {
      //   this.set_time_state_para.state = item.stateFlag ? 1 : 0
      // }
      this.set_time_state_para.state = item.stateFlag ? 1 : 0
      this.set_time_state_para.curcheHandsTimeId = item.curcheHandsTimeId
      let obj = {context: this, para: this.set_time_state_para, isIndicator: false, successFun: (response) => {
      }}
      service.request(obj)
    }
  }
}
</script>
<style scoped>
.mint-switch-input{background:none;}
</style>



// WEBPACK FOOTER //
// remindList.vue?43cb0e62